define('collections/distributor_personals',['require','collections/base','models/distributor_personal'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/distributor_personal");

    return BaseCollection.extend({
        model: Model,
        url: 'distributor-managers.json'
    });
});

